const ServiceTimeslot = function () {
    const SERVICE_TYPE_ECOMM_DELIVERY = 'HOME_DELIVERY';
    const SERVICE_TYPE_ECOMM_PICKUP = 'PICK_UP_IN_STORE';
    const SERVICE_TYPE_MPRIORITY_DELIVERY = 'MPRIORITY_HOME_DELIVERY';
    const SERVICE_TYPE_MPRIORITY_PICKUP = 'MPRIORITY_PICKUP';
    const SERVICE_TYPE_EXPRESS_DELIVERY = 'CORNERSHOP_HOME_DELIVERY';
    let selectedTimeslotId;
    let closeServiceAndTimeslotCallback;
    let cartStoreHasChanged = false;
    let cartTypeHasChanged = false;
    let cartHasStore = false;
    let cartLoadNewPrices = false;
    let selectDeliveryService = '.select--delivery-service';
    let selectPickupService = '.select--pickup-service';
    let activePickupTimeslotContainer = '.timeslotPickupContainer.activeTimeslotContainer';
    let activeDeliveryTimeslotContainer = '.timeslotDeliveryContainer.activeTimeslotContainer';
    let serviceAndTimeslotClass = '#modal-service-and-timeslot';
    let assignTimeslot = false;
    let productToAddToCart;
    let errorBoxForAddToCart;

    function init() {
        $('.openStoreLocator').click(function () {
            openServiceAndTimeslot.bind(this)();
        });

        $('.openBanner').click(function () {
            openServiceAndTimeslotBanner();
        });

        if (isServiceTimeslotWebviewMode()) {
            bindWebviewEvents();
        }

        stickyTimeslotBanner();

        if (!isServiceTimeslotWebviewMode()) {
            sidePanelControl.remodalCloseEvent();
        }

        $('.overlayServiceBox .openStoreLocator').click(function () {
            onPanelView('product tile overlay', false);
        });
        $('#banner-service-and-timeslot .openStoreLocator').click(function () {
            onPanelView('sticky bar', false);
        });


    }

    //!****************************************************************
    // Ajax calls
    //!****************************************************************

    function openModalServiceAndTimeslot(url) {

        let $isModalOpen = $('.st_panel.remodal-is-opened');
        if (!$isModalOpen.length) {
            openServiceTimeslot();
        } else {
            $isModalOpen.addClass('in-progress');
        }

        $.ajax({
            url: url,
            type: 'GET',
            contentType: 'application/json',
            dataType: 'html',
            cache: false,
            success: function (data, code, jqXHR) {
                replaceContentModalServiceAndTimeslot(data, false);
            },
            error: function (jqXHR) {
                TINK.redirectIfConflict(jqXHR);
            }
        });
    }

    function assignStoreToCart(serviceTypeChosen, storeId, deliveryPostalCode, servicePointId, partnerCode, captchaEnabledAndVisible) {
        deactivateServiceAndTimeslotButtons();
        let recaptchaResponse = serviceCaptcha.getResponse();
        let formStateId = $(serviceAndTimeslotClass + ' .st--main').attr('data-form-state-id');
        $.ajax({
            url: assignStoreToCartUrl,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'html',
            data: JSON.stringify({
                'serviceType': serviceTypeChosen,
                'storeId': storeId,
                'deliveryPostalCode': deliveryPostalCode,
                'servicePointId': servicePointId,
                'partnerCode': partnerCode,
                'g-recaptcha-response': recaptchaResponse,
                'formStateId': formStateId,
                'captchaEnabledAndInvisible': captchaEnabledAndVisible
            }),
            cache: false,
            success: function (data, code, jqXHR) {
                updateCartHasStore(jqXHR);
                updateCartWithoutTimeslot(true);
                updateHeaderAfterServiceAndTimeslotRequest(jqXHR);
                if (jqXHR.getResponseHeader('cartStoreHasChanged') === 'true') {
                    cartStoreHasChanged = true;
                }
                if (jqXHR.getResponseHeader('cartTypeHasChanged') === 'true') {
                    cartTypeHasChanged = true;
                }
                if (jqXHR.getResponseHeader('cartLoadNewPrices') === 'true') {
                    cartLoadNewPrices = true;
                }
                if (typeof serviceType != 'undefined') {
                    serviceType = jqXHR.getResponseHeader('cartServiceType');
                }

                $('#closeServiceAndTimeslotModal').attr('disabled', false);
                if (jqXHR.getResponseHeader('timeslotError') === 'true') {
                    replaceContentModalServiceAndTimeslot(data, false);
                    $(serviceAndTimeslotClass).find('button').not('footer button').attr('disabled', true);
                } else {
                    hideModalServiceAndTimeslot(true);
                }

                if (isInWebview()) {
                    sendWebviewReloadCartToDevice();
                }
            },
            error: function (jqXHR) {
                if (jqXHR.status === 400) {
                    if (jqXHR.getResponseHeader('cartStoreHasChanged') === 'true') {
                        cartStoreHasChanged = true;
                    }
                    if (jqXHR.getResponseHeader('cartTypeHasChanged') === 'true') {
                        cartTypeHasChanged = true;
                    }
                    if (jqXHR.getResponseHeader('cartLoadNewPrices') === 'true') {
                        cartLoadNewPrices = true;
                    }
                    if (jqXHR.getResponseHeader('recaptchaFailed') === 'true') {
                        displayCaptchaError($('#serviceCaptchaError'));
                        updateHeaderAfterServiceAndTimeslotRequest(jqXHR);
                        $(serviceAndTimeslotClass).find('button').not('footer button').attr('disabled', false);
                        serviceCaptcha.resetCaptcha();
                        return false;
                    }
                    updateCartHasStore(jqXHR);
                    updateHeaderAfterServiceAndTimeslotRequest(jqXHR);
                    $(serviceAndTimeslotClass).find('button').not('footer button').attr('disabled', false);
                    serviceCaptcha.resetCaptcha();
                } else {
                    TINK.redirectIfConflict(jqXHR);
                }
            }
        });
    }

    function assignStoreAndTimeslotToCart(serviceTypeChosen, storeId, deliveryPostalCode, servicePointId, partnerCode, slot, captchaEnabledAndInvisible, slotFrom, slotTo, slotDeliveryPartner, slotStoreId) {
        deactivateServiceAndTimeslotButtons();
        let recaptchaResponse = serviceCaptcha.getResponse();
        let formStateId = $(serviceAndTimeslotClass + ' .st--main').attr('data-form-state-id');
        $.ajax({
            url: assignStoreAndTimeslotToCartUrl,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'html',
            data: JSON.stringify({
                'serviceType': serviceTypeChosen,
                'storeId': storeId,
                'deliveryPostalCode': deliveryPostalCode,
                'servicePointId': servicePointId,
                'partnerCode': partnerCode,
                'g-recaptcha-response': recaptchaResponse,
                'formStateId': formStateId,
                'slot': slot,
                'captchaEnabledAndInvisible': captchaEnabledAndInvisible,
                'slotDeliveryPartner': slotDeliveryPartner,
                'slotStoreId': slotStoreId,
                'slotFrom': slotFrom,
                'slotTo': slotTo,
                'inCheckoutPage': isInCheckoutPage(true)
            }),
            cache: false,
            success: function (data, code, jqXHR) {
                selectedTimeslotId = slot;
                updateCartHasStore(jqXHR);
                updateCartWithoutTimeslot(false);
                updateHeaderAfterServiceAndTimeslotRequest(jqXHR);

                if (jqXHR.getResponseHeader('closeModal') === 'true') {
                    hideModalServiceAndTimeslot(true);

                    if (isInWebview()) {
                        sendWebviewReloadCartToDevice();
                    }
                } else {
                    replaceContentModalServiceAndTimeslot(data, false);
                }

                if (jqXHR.getResponseHeader('cartStoreHasChanged') === 'true') {
                    cartStoreHasChanged = true;
                }
                if (jqXHR.getResponseHeader('cartTypeHasChanged') === 'true') {
                    cartTypeHasChanged = true;
                }
                if (jqXHR.getResponseHeader('cartLoadNewPrices') === 'true') {
                    cartLoadNewPrices = true;
                }
                if (typeof serviceType != 'undefined') {
                    serviceType = jqXHR.getResponseHeader('cartServiceType');
                }

                if (jqXHR.getResponseHeader('timeslotError') !== 'true' && jqXHR.getResponseHeader('recaptchaFailed') !== 'true') {
                    setTimeslotConfirmationAlert();
                }

                $('#closeServiceAndTimeslotModal').attr('disabled', false);
            },
            error: function (jqXHR) {
                selectedTimeslotId = undefined;
                if (jqXHR.status === 400) {
                    if (jqXHR.getResponseHeader('cartStoreHasChanged') === 'true') {
                        cartStoreHasChanged = true;
                    }
                    if (jqXHR.getResponseHeader('cartTypeHasChanged') === 'true') {
                        cartTypeHasChanged = true;
                    }
                    if (jqXHR.getResponseHeader('cartLoadNewPrices') === 'true') {
                        cartLoadNewPrices = true;
                    }
                    if (jqXHR.getResponseHeader('recaptchaFailed') === 'true') {
                        displayCaptchaError($('#serviceCaptchaError'));
                        updateHeaderAfterServiceAndTimeslotRequest(jqXHR);
                        $(serviceAndTimeslotClass).find('button').not('footer button').attr('disabled', false);
                        serviceCaptcha.resetCaptcha();
                        return false;
                    }
                    updateCartHasStore(jqXHR);
                    updateHeaderAfterServiceAndTimeslotRequest(jqXHR);
                    $(serviceAndTimeslotClass).find('button').not('footer button').attr('disabled', false);
                    serviceCaptcha.resetCaptcha();
                } else {
                    TINK.redirectIfConflict(jqXHR);
                }
            }
        });
    }


    //!****************************************************************
    // Modal management
    //!****************************************************************

    function openServiceAndTimeslotBanner() {
        let $bannerServiceAndTimeslot = $("#banner-service-and-timeslot");
        if (isBannerServiceAndTimeslotOpen()) {
            $bannerServiceAndTimeslot.addClass('reduced');
        } else {
            $bannerServiceAndTimeslot.removeClass('reduced');
        }
    }

    function openServiceAndTimeslot(postalCode, product, errorBox, serviceTypeFromOverlay) {
        cartStoreHasChanged = false;
        cartTypeHasChanged = false;
        productToAddToCart = product;
        errorBoxForAddToCart = errorBox;
        let $this;
        if (postalCode != null) {
            $this = $(postalCode);
        } else {
            $this = $(this);
        }

        let url = $this.data('target');
        let $postalCodeAttr = $this.attr('service-timeslot-postalcode');
        let fromSubmit = $this.attr('from-submit');
        if (!fromSubmit) {
            fromSubmit = false;
        }

        if (url) {
            if (postalCode !== undefined) {
                url += '?deliveryPostalCode=' + postalCode + '&fromSubmit=' + fromSubmit;
            } else if (typeof $postalCodeAttr != 'undefined') {
                url += '?deliveryPostalCode=' + $postalCodeAttr + '&fromSubmit=' + fromSubmit;
            } else {
                url += '?fromSubmit=' + false;
            }
        } else {
            url = $this.attr('service-and-timeslot-target');
            let $postalCodeAttr = $this.attr('service-timeslot-postalcode');
            if (typeof $postalCodeAttr != 'undefined') {
                url += '?deliveryPostalCode=' + $postalCodeAttr + '&fromSubmit=' + fromSubmit;
            } else {
                url += '?fromSubmit=' + fromSubmit;
            }
        }

        if (typeof serviceTypeFromOverlay != 'undefined') {
            url += '&serviceTypeFromOverlay=' + serviceTypeFromOverlay;
        }

        closeServiceAndTimeslotCallback = $this.data('onstoreselectclose');
        if (!closeServiceAndTimeslotCallback || closeServiceAndTimeslotCallback === "") {
            closeServiceAndTimeslotCallback = null;
        }

        openModalServiceAndTimeslot(url);
    }

    function isBannerServiceAndTimeslotOpen() {
        return !$('#banner-service-and-timeslot').hasClass('reduced');
    }

    function replaceContentModalServiceAndTimeslot(data, closeModal) {
        replaceSection(data);
        if (!closeModal) {
            initPostalCodeFormContainer();
            bindServiceToggle();
            bindServiceFlow();
            initFlexible();
            initServiceTimeslot();
            if (isServiceTimeslotWebviewMode()) {
                bindCloseButton();
            }
            bindTimeslotButtons();
            manageFooterButtonsStates();
            setCurrentServiceType();
            gaClickEvents();
            bindCaptcha();
        }

    }

    function replaceSection(data) {
        data = data.trim();
        let $modal = $('#modal-service-and-timeslot');
        let $replaceSection = $modal.find('.replaceMePlease');
        if ($replaceSection.length > 0) {
            $replaceSection.html('');
        }

        $replaceSection.html(data);

        let $postalCodeInput = $('#deliveryPostalCode');
        if (data !== '') {
            $postalCodeInput.focus();
        }

    }

    function hideModalServiceAndTimeslot(success) {
        if (isServiceTimeslotWebviewMode()) {
            let status = success ? 'CONFIRMATION' : 'CANCELLATION';
            sendCloseWebviewEventToDevice(status);
        } else {
            closeServiceTimeslot();
        }
    }

    function initPostalCodeFormContainer() {
        let $deliveryPostalCodeInput = $('#deliveryPostalCode');
        let $postalCodeFormContainer = $(serviceAndTimeslotClass + ' form.st__postalCode');
        $postalCodeFormContainer.submit(function (e) {
            e.preventDefault();
            openModalServiceAndTimeslot.bind(this)(serviceUrl + '?deliveryPostalCode=' + $deliveryPostalCodeInput.val() + '&fromSubmit=' + true);
            return false;
        });
    }

    function bindServiceToggle() {
        let $serviceTypeChecked = getToggleServiceType();
        manageServiceToggle($serviceTypeChecked, true);
        bindFlexibleDeliveryStoresSelect();
        bindPickupStoresSelect();

        //On change service's toggle
        $(serviceAndTimeslotClass + ' input[name="radioServiceType"]').change(function () {
            manageServiceToggle(this.value);
            let $inputTimeslotSelected;
            if (this.value == SERVICE_TYPE_ECOMM_DELIVERY) {
                let $inputTimeslotDeliverySelected = $(selectDeliveryService).find(activeDeliveryTimeslotContainer).find('input[name="select-timeslot-home_delivery"]:checked');
                let $inputTimeslotMprioDeliverySelected = $(selectDeliveryService).find(activeDeliveryTimeslotContainer).find('input[name="select-timeslot-mpriority_home_delivery"]:checked');
                let $inputTimeslotExpressSelected = $('input[name="select-timeslot-express_delivery"]:checked');
                $inputTimeslotSelected = $inputTimeslotDeliverySelected.length ? $inputTimeslotDeliverySelected : $inputTimeslotMprioDeliverySelected;
                if ($inputTimeslotExpressSelected.length && $('input[name="select-timeslot-express_delivery"]').attr('data-express-delivery-is-reserved') == 'true') {
                    sidePanelControl.displayReservedTag($inputTimeslotSelected)
                } else if ($inputTimeslotExpressSelected.length) {
                    sidePanelControl.showExpressAlert();
                    manageReservedTextFooter($inputTimeslotExpressSelected);
                } else if ($inputTimeslotSelected.length) {
                    manageReservedTextFooter($inputTimeslotSelected);
                }
                manageFooterInfo($inputTimeslotSelected, !$inputTimeslotSelected.length && $inputTimeslotExpressSelected.length);
            } else if (this.value == SERVICE_TYPE_ECOMM_PICKUP) {
                if (getCurrentServiceType() === SERVICE_TYPE_ECOMM_PICKUP) {
                    $inputTimeslotSelected = $(selectPickupService).find(activePickupTimeslotContainer).find('input[name="select-timeslot-pick_up_in_store"]:checked');
                } else {
                    $inputTimeslotSelected = $(selectPickupService).find(activePickupTimeslotContainer).find('input[name="select-timeslot-mpriority_pickup"]:checked');
                }
                manageReservedTextFooter($inputTimeslotSelected);
                manageFooterInfo($inputTimeslotSelected, false);
            }
        });

        let $timeSlotRadioInputService = $('.service-timeslot .st__serviceType input[name=radioServiceType]:not(:disabled)');
        if ($timeSlotRadioInputService.length) {
            $timeSlotRadioInputService.next('label').focus();
        }
    }

    function bindServiceFlow() {
        $('.chooseLater').click(function () {
            assignTimeslot = false;
            submitAssignStore();
        });

        $('#confirmTimeslot').click(function () {
            assignTimeslot = true;
            submitAssignStore();
        });

    }

    function bindCaptcha() {
        serviceCaptcha.removeCaptcha();
        serviceCaptcha.renderCaptcha();
    }

    function submitAssignStore() {
        if (serviceCaptcha.isEnabledAndInvisible()) {
            serviceCaptcha.executeCaptcha();
        } else {
            findInfoAndAssignStoreToCart();
        }
    }

    window['executeFindInfoAndAssignStoreToCart'] = function (token) {
        findInfoAndAssignStoreToCart();
    }

    function findInfoAndAssignStoreToCart() {
        let partnerCode;
        if (window['partnerCollection'] || window['partnerCollection'] != null) {
            partnerCode = window['partnerCollection'].partnerCode;
        }

        let storeId;
        let deliveryPostalCode;
        let servicePointId;
        let serviceType;
        let $serviceTypeInput = getCurrentServiceType();

        if ($serviceTypeInput === SERVICE_TYPE_ECOMM_DELIVERY) {
            serviceType = SERVICE_TYPE_ECOMM_DELIVERY;
            let $deliveryStore = $(serviceAndTimeslotClass + ' input[name="deliveryStore"]');
            storeId = $deliveryStore.attr('data-store-id');
            deliveryPostalCode = $deliveryStore.attr('data-delivery-postal-code');
            servicePointId = $deliveryStore.attr('data-service-point-id');
            pushDataLayerServiceAndTimeslotDelivery($deliveryStore.attr('data-store-name'), false);
        } else if ($serviceTypeInput === SERVICE_TYPE_ECOMM_PICKUP) {
            serviceType = SERVICE_TYPE_ECOMM_PICKUP;
            let $pickupStore = $(serviceAndTimeslotClass + ' input[name="pickUpStoreSelect"]:checked');
            storeId = $pickupStore.attr('data-store-id');
            servicePointId = $pickupStore.attr('data-pickup-service-point-id');
            deliveryPostalCode = $pickupStore.attr('data-delivery-postal-code');
            pushDataLayerServiceAndTimeslotPickup($pickupStore.attr('data-store-name'), false);
        } else if ($serviceTypeInput === SERVICE_TYPE_MPRIORITY_DELIVERY) {
            serviceType = SERVICE_TYPE_MPRIORITY_DELIVERY;
            let $deliveryStore = $(serviceAndTimeslotClass + ' input[name="flexibleDeliveryStoreSelect"]:checked');
            storeId = $deliveryStore.attr('data-store-id');
            servicePointId = $deliveryStore.attr('data-service-point-id');
            deliveryPostalCode = $deliveryStore.attr('data-delivery-postal-code');
            pushDataLayerServiceAndTimeslotDelivery($deliveryStore.attr('data-store-name'), true);
        } else if ($serviceTypeInput === SERVICE_TYPE_MPRIORITY_PICKUP) {
            serviceType = SERVICE_TYPE_MPRIORITY_PICKUP;
            let $pickupStore = $(serviceAndTimeslotClass + ' input[name="pickUpStoreSelect"]:checked');
            storeId = $pickupStore.attr('data-store-id');
            servicePointId = $pickupStore.attr('data-flexible-service-point-id');
            deliveryPostalCode = $pickupStore.attr('data-delivery-postal-code');
            pushDataLayerServiceAndTimeslotPickup($pickupStore.attr('data-store-name'), true);
        } else if ($serviceTypeInput === SERVICE_TYPE_EXPRESS_DELIVERY) {
            serviceType = SERVICE_TYPE_EXPRESS_DELIVERY;
            let $expressDeliveryStore = $(serviceAndTimeslotClass + ' input[name="expressDeliveryStore"]');
            storeId = $expressDeliveryStore.attr('data-store-id');
            servicePointId = $expressDeliveryStore.attr('data-service-point-id');
            deliveryPostalCode = $expressDeliveryStore.attr('data-delivery-postal-code');
            pushDataLayerServiceAndTimeslotExpressDelivery($expressDeliveryStore.attr('data-store-name'));
        } else {
            return;
        }

        let captchaEnabledAndInvisible = serviceCaptcha.isEnabledAndInvisible();
        if (assignTimeslot && $serviceTypeInput !== SERVICE_TYPE_EXPRESS_DELIVERY) {
            let $timeslotInput = $('.service-timeslot input[name="select-timeslot-' + serviceType.toLowerCase() + '"]:checked');
            let slot = $timeslotInput.attr('slot-id');
            let slotStoreId = $timeslotInput.attr('slot-store-id');
            let slotDeliveryPartner = $timeslotInput.attr('slot-delivery');
            let slotFrom = $timeslotInput.attr('slot-from');
            let slotTo = $timeslotInput.attr('slot-to');
            assignStoreAndTimeslotToCart(serviceType, storeId, deliveryPostalCode, servicePointId, partnerCode, slot, captchaEnabledAndInvisible, slotFrom, slotTo, slotDeliveryPartner, slotStoreId);
        } else {
            // TODO : T4286-11920 check for express delivery if we need the following function
            // cleanServiceErrorInUrl(serviceType);
            assignStoreToCart(serviceType, storeId, deliveryPostalCode, servicePointId, partnerCode, captchaEnabledAndInvisible);
        }
    }

    function bindCloseButton() {
        //Define handler for close event
        $('#closeServiceAndTimeslotModal').unbind().click(function () {
            onPanelClose();
            pushDataLayerServiceAndTimeslotTimeslotClose();
            hideModalServiceAndTimeslot(false);
        });
        $('#modal-service-and-timeslot .remodal-wrapper').unbind().on('mousedown', function (e) {
            let $parentIgnoreNode = document.querySelector('.st_panel');
            if (e.target !== $parentIgnoreNode && !$parentIgnoreNode.contains(e.target) && e.target.id !== 'closeServiceAndTimeslotModal') {
                onPanelClose();
                hideModalServiceAndTimeslot(false);
            }
        });
    }

    function bindTimeslotButtons() {
        $('.service-timeslot input[name="select-timeslot-home_delivery"]').change(function () {
            let $timeslotExpress = $('input[name="select-timeslot-express_delivery"]');
            if ($timeslotExpress.length) {
                $timeslotExpress.prop('checked', false);
            }
            manageReservedTextFooter($(this));
            $(serviceAndTimeslotClass).data('service-type-selected', SERVICE_TYPE_ECOMM_DELIVERY);
            manageFooterInfo($(this), false);
        });

        $('.service-timeslot input[name="select-timeslot-pick_up_in_store"]').change(function () {
            manageReservedTextFooter($(this));
            $(serviceAndTimeslotClass).data('service-type-selected', SERVICE_TYPE_ECOMM_PICKUP);
            manageFooterInfo($(this), false);
        });

        $('.service-timeslot input[name="select-timeslot-mpriority_pickup"]').change(function () {
            manageReservedTextFooter($(this));
            $(serviceAndTimeslotClass).data('service-type-selected', SERVICE_TYPE_MPRIORITY_PICKUP);
            manageFooterInfo($(this), false);
        });

        $('.service-timeslot input[name="select-timeslot-mpriority_home_delivery"]').change(function () {
            let $timeslotExpress = $('input[name="select-timeslot-express_delivery"]');
            if ($timeslotExpress.length) {
                $timeslotExpress.prop('checked', false);
            }
            manageReservedTextFooter($(this));
            $(serviceAndTimeslotClass).data('service-type-selected', SERVICE_TYPE_MPRIORITY_DELIVERY);
            manageFooterInfo($(this), false);
        });

        $('.service-timeslot input[name="select-timeslot-express_delivery"]').change(function () {
            let $timeslotDelivery = $('input[name="select-timeslot-home_delivery"]');
            if ($timeslotDelivery.length) {
                $timeslotDelivery.prop('checked', false);
            }
            let $timeslotMprioDelivery = $('input[name="select-timeslot-mpriority_home_delivery"]');
            if ($timeslotMprioDelivery.length) {
                $timeslotMprioDelivery.prop('checked', false);
            }
            let isServiceExpressReserved = $('input[name="select-timeslot-express_delivery"]').attr('data-express-delivery-is-reserved');
            manageReservedTextFooter($(this), isServiceExpressReserved);
            $(serviceAndTimeslotClass).data('service-type-selected', SERVICE_TYPE_EXPRESS_DELIVERY);
            manageFooterInfo(null, true);
        });
    }

    function manageFooterButtonsStates() {
        if ($('#noService').length) {
            sidePanelControl.disableConfirmTimeslotButton(true);
            sidePanelControl.disableChooseLaterButton(true);
        }
    }

    function gaClickEvents() {
        $('.deliveryTimeslotAlert button').click(function () {
            onPanelServiceClick('try pick-up');
        });
        $('.pickupTimeslotAlert button').click(function () {
            onPanelServiceClick('try delivery');
        });
        $('#confirmTimeslot').click(function () {
            onPanelServiceClick('select timeslot');
        });
        $('#chooseLater').click(function () {
            onPanelServiceClick('choose later');
            $('.data-container-GA .data-timeslot-type-GA').data('ga-timeslot-type', 'empty');
        });
    }

    function manageReservedTextFooter($timeslotSelected, isServiceExpressReserved) {
        let footerReservedSlot = $('.footerReservedSlot').attr('data-slot-reserved-id');
        if ((isServiceExpressReserved && footerReservedSlot === undefined) || ($timeslotSelected.attr('slot-id') && $timeslotSelected.attr('slot-id') === footerReservedSlot)) {
            sidePanelControl.displayReservedTag($timeslotSelected);
        } else {
            $('.footerReservedSlot').hide();
        }
    }

    function manageFooterInfo($inputSelectTimeslot, expressDeliverySelected) {
        let $footerInfoWrapper = $('.st--footer__info');
        if (expressDeliverySelected) {
            $footerInfoWrapper.find('.infoTimeslotDay').text($('.express-delivery-timeslot-msg').text());
            $footerInfoWrapper.find('.infoTimeslotDay').removeClass('hide');
            $footerInfoWrapper.find('.infoTimeslotFrom').addClass('hide');
            $footerInfoWrapper.find('.infoTimeslotTime').addClass('hide');

            if ($('#modal-service-and-timeslot .st--main').data('express-item-entry') <= $('#modal-service-and-timeslot .st--main').data('max-item-number')) {
                sidePanelControl.disableConfirmTimeslotButton(false);
                sidePanelControl.disableChooseLaterButton(false);
            } else if ($('#modal-service-and-timeslot .st--main').data('express-item-entry') == 0) {
                sidePanelControl.disableConfirmTimeslotButton(false);
                sidePanelControl.disableChooseLaterButton(false);
            } else {
                sidePanelControl.disableConfirmTimeslotButton(true);
                sidePanelControl.disableChooseLaterButton(true);
            }
        } else if ($inputSelectTimeslot != null && $inputSelectTimeslot.length) {
            let selectedDay = $inputSelectTimeslot.closest(".selection-box").attr("data-day-date");
            let $activeDay = $('.activeDaySlider').find('[data-timeslot-date=' + selectedDay + ']');
            let $activeTimeslotHour = $inputSelectTimeslot.parent().find('.timeslot--title').html();
            $footerInfoWrapper.find('.infoTimeslotDay').text($activeDay.text());
            $footerInfoWrapper.find('.infoTimeslotDay').removeClass('hide');
            $footerInfoWrapper.find('.infoTimeslotFrom').text(lang === 'fr' ? ' à ' : ' at ').removeClass('hide');
            $footerInfoWrapper.find('.infoTimeslotTime').text($activeTimeslotHour);
            $footerInfoWrapper.find('.infoTimeslotTime').removeClass('hide');
            sidePanelControl.disableConfirmTimeslotButton(false);
            sidePanelControl.disableChooseLaterButton(false);

            if (sidePanelControl.isCurrentDayInNewFlyerCoverage()) {
                const $tooltipFlyerIntercept = $('.tooltipInterceptNewFlyer');
                const $overlayFlyerIntercept = $('.overlay-tooltip-intercetp-new-flyer');
                serviceTimeslotControl.openTooltipInterceptModal($tooltipFlyerIntercept, $overlayFlyerIntercept);
            }

        } else {
            $footerInfoWrapper.find('.infoTimeslotDay').text('');
            $footerInfoWrapper.find('.infoTimeslotDay').removeClass('hide');
            $footerInfoWrapper.find('.infoTimeslotFrom').text('').removeClass('hide');
            $footerInfoWrapper.find('.infoTimeslotTime').text('');
            $footerInfoWrapper.find('.infoTimeslotTime').removeClass('hide');
            sidePanelControl.disableConfirmTimeslotButton(true);

            if (!$('input[name="deliveryStore"]').length && !$('.postalCodeNotSubmittedAlert').hasClass('hide')) {
                sidePanelControl.disableChooseLaterButton(true);
            }
        }

        if ($inputSelectTimeslot != null && $inputSelectTimeslot.length && $inputSelectTimeslot.attr('slot-id') == $('.footerReservedSlot').attr('data-slot-reserved-id')) {
            sidePanelControl.disableConfirmTimeslotButton(true);
        }
    }

    function manageServiceToggle(serviceType, onInit) {
        sidePanelControl.hidePostalCodeNotSubmittedAlert();
        if (serviceType === SERVICE_TYPE_ECOMM_DELIVERY) {
            // Hide all pickup store DOM elements and show all delivery service DOM elements
            $(selectPickupService).addClass('hide');
            $(selectDeliveryService).removeClass('hide');

            // add the selector activeDaySlider
            $('.timeslot-days-slick.selectDeliveryStore.activeDeliveryStore').addClass('activeDaySlider');

            // remove the selector activeDaySlider from previous day slider
            $('.section-day-selection .select--pickup-store').removeClass('activeDaySlider');
            $('#deliveryRadio').prop('checked', true);

            setCurrentServiceType();

            // Load Timeslot if there no loaded timeslot for this service type
            let $selectTimeslotService = $(".timeslot-days-slick.selectDeliveryStore").first();
            if ($selectTimeslotService.attr("data-init-timeslot") === "false") {
                sidePanelControl.loadAndShowFirstAvailableTimeslot($(".timeslot-days-slick.selectDeliveryStore"));
                onInit = false;
            } else if (!onInit) {
                showReservedOrFirstAvailableTimeslot();
            }

            showHideFlexibleDeliveryBtns();
            if (typeof showEmptyDeliverySection !== 'undefined' && showEmptyDeliverySection) {
                sidePanelControl.showPostalCodeNotSubmittedAlert();
            }
        } else {
            // Show all pickup store DOM elements and Hide all delivery service DOM elements
            $(selectDeliveryService).addClass('hide');
            $(selectPickupService).removeClass('hide');

            // add the selector activeDaySlider
            $('.timeslot-days-slick.select--pickup-store.activePickupStore').addClass('activeDaySlider');

            // remove the selector activeDaySlider from previous day slider
            $('.timeslot-days-slick.selectDeliveryStore').removeClass('activeDaySlider');
            if ($('#pickUpRadio').length) {
                $('#pickUpRadio').prop('checked', true);
            }

            if ($('#timeslotStoreSelect .selected-store-name').length) {
                $('.sp_footer-store-name').text($('#timeslotStoreSelect .selected-store-name').html() + ' ' + $('#timeslotStoreSelect .selected-store-address').html());
            } else {
                $('.sp_footer-store-name').text('');
            }

            setCurrentServiceType();

            // Load Timeslot if there's no loaded timeslot for this service type
            let $selectTimeslotService = $(".timeslot-days-slick.select--pickup-store").first();
            if ($selectTimeslotService.attr("data-init-timeslot") === "false") {
                sidePanelControl.loadAndShowFirstAvailableTimeslot($(".timeslot-days-slick.select--pickup-store"));
                onInit = false;
            } else if (!onInit) {
                showReservedOrFirstAvailableTimeslot();
            }

            showHideFlexiblePickupBtns();
        }
        // Show the first available timeslot
        if (onInit === true || $('.day-selection_btn.day__active').length === 0) {
            sidePanelControl.showFirstAvailableTimeslot();
        }
    }

    function setCurrentServiceType() {
        let activeServiceType = $('.activeDaySlider').closest("[data-store-id]").attr('data-service-type');
        let serviceTypeToggle = getToggleServiceType();

        if (serviceTypeToggle == SERVICE_TYPE_ECOMM_DELIVERY) {
            let $expressDeliverySelected = $('input[name="select-timeslot-express_delivery"]:checked');
            if (activeServiceType === SERVICE_TYPE_ECOMM_DELIVERY && !$expressDeliverySelected.length) {
                $(serviceAndTimeslotClass).data('service-type-selected', SERVICE_TYPE_ECOMM_DELIVERY);
            } else if ($expressDeliverySelected.length) {
                $(serviceAndTimeslotClass).data('service-type-selected', SERVICE_TYPE_EXPRESS_DELIVERY);
            } else if (activeServiceType === SERVICE_TYPE_MPRIORITY_DELIVERY) {
                $(serviceAndTimeslotClass).data('service-type-selected', SERVICE_TYPE_MPRIORITY_DELIVERY);
            }
        } else if (serviceTypeToggle == SERVICE_TYPE_ECOMM_PICKUP) {
            if (activeServiceType === SERVICE_TYPE_ECOMM_PICKUP) {
                $(serviceAndTimeslotClass).data('service-type-selected', SERVICE_TYPE_ECOMM_PICKUP);
            } else if (activeServiceType === SERVICE_TYPE_MPRIORITY_PICKUP) {
                $(serviceAndTimeslotClass).data('service-type-selected', SERVICE_TYPE_MPRIORITY_PICKUP);
            }
        }
    }

    function getCurrentServiceType() {
        return $(serviceAndTimeslotClass).data('service-type-selected');
    }

    function bindPickupStoresSelect() {
        $('.selection-box.select--pickup-service .pickupStoreSelection input[name="pickUpStoreSelect"]').change(function () {
            var showFirstAvailableTimeslot = true;
            var selectedStoreName = $(this).data('store-name');
            var selectedStoreAddress = $(this).data('store-address');
            // First option : search the pickup std service point id, second option : search the pickup flexible
            var selectedStoreId = $(this).data('store-id');

            let $previousPickupStoreChecked = $('.selection-box.select--pickup-service input[name="pickUpStoreSelect"]').parent().closest(".hide");

            // Show the previous selected store to dropdown
            $previousPickupStoreChecked.removeClass("hide");

            // Hide the previous selected store from dropdown
            $(this).parent().addClass("hide");

            // change the new selected pickup store informations
            $('#timeslotStoreSelect .selected-store-name').text(selectedStoreName);
            $('#timeslotStoreSelect .selected-store-address').text(selectedStoreAddress);

            sidePanelControl.closeStoreToggle();

            // if this selected store has no timeslots, then load and show them
            if ($(this).attr("data-init-timeslot") === "false") {
                sidePanelControl.loadAndShowFirstAvailableTimeslot($(".timeslot-days-slick.select--pickup-store[data-store-id=" + selectedStoreId + "]"));
                showFirstAvailableTimeslot = false;
            }

            // Activate Timeslot container and desactivate the old one
            $('.selection-box-container.timeslotPickupContainer[data-store-id]').removeClass('activeTimeslotContainer').addClass("hide");
            $('.selection-box-container.timeslotPickupContainer[data-store-id=' + selectedStoreId + ']').addClass('activeTimeslotContainer').removeClass("hide");

            //hide previous days slick
            let previousStoreId = $previousPickupStoreChecked.find("[data-store-id]").first().data('store-id');
            $(".timeslot-days-slick.select--pickup-store[data-store-id=" + previousStoreId + "]").addClass("hide").removeClass('activePickupStore activeDaySlider');
            //show the new days slick
            $(".timeslot-days-slick.select--pickup-store[data-store-id=" + selectedStoreId + "]").removeClass("hide").addClass('activePickupStore activeDaySlider');

            //set selected serviceType
            setCurrentServiceType();

            //change footer info
            if (typeof selectedStoreName != 'undefined' && typeof selectedStoreAddress != 'undefined') {
                $('.sp_footer-store-name').text(selectedStoreName + ' ' + selectedStoreAddress);
            }

            if (showFirstAvailableTimeslot) {
                showReservedOrFirstAvailableTimeslot();
            }

            let $inputTimeslotSelected;
            if (getCurrentServiceType() === SERVICE_TYPE_ECOMM_PICKUP) {
                $inputTimeslotSelected = $(selectPickupService).find(activePickupTimeslotContainer).find('input[name="select-timeslot-pick_up_in_store"]:checked');
            } else {
                $inputTimeslotSelected = $(selectPickupService).find(activePickupTimeslotContainer).find('input[name="select-timeslot-mpriority_pickup"]:checked');
            }
            manageFooterInfo($inputTimeslotSelected, false);
            showHideFlexiblePickupBtns();
        });
    }

    function bindFlexibleDeliveryStoresSelect() {
        $('.selection-box.select--delivery-service .flexibleDeliveryDropdown input[name="flexibleDeliveryStoreSelect"]').change(function () {
            var showFirstAvailableTimeslot = true;
            var selectedStoreName = $(this).data('store-name');
            var selectedStoreAddress = $(this).data('store-address');
            var selectedStoreId = $(this).data('store-id');
            var selectedServicePointId = $(this).data('service-point-id');

            let $previousFlexDeliveryStoreChecked = $('.selection-box.select--delivery-service input[name="flexibleDeliveryStoreSelect"]').parent().closest(".hide");

            // Show the previous selected store to dropdown
            $previousFlexDeliveryStoreChecked.removeClass("hide");

            // Hide the previous selected store from dropdown
            $(this).parent().addClass("hide");

            // change the new selected flexible delivery store informations
            $('#selectedFlexibleDeliveryStore .selected-store-name').text(selectedStoreName);
            $('#selectedFlexibleDeliveryStore .selected-store-address').text(selectedStoreAddress);

            sidePanelControl.closeFlexibleDeliveryDropdown();

            // if this selected store has no timeslots, then load and show them
            if ($(this).attr("data-init-timeslot") === "false") {
                sidePanelControl.loadAndShowFirstAvailableTimeslot($(".timeslot-days-slick.selectFlexibleDeliveryStore[data-service-point-id=" + selectedServicePointId + "][data-store-id=" + selectedStoreId + "]"));
                showFirstAvailableTimeslot = false;
            }

            // Activate Timeslot container and desactivate the old one
            $('.selection-box-container.timeslotDeliveryContainer[data-store-id]').removeClass('activeTimeslotContainer').addClass("hide");
            $('.selection-box-container.timeslotDeliveryContainer[data-service-point-id=' + selectedServicePointId + '][data-store-id=' + selectedStoreId + ']').addClass('activeTimeslotContainer').removeClass('hide');

            //hide previous days slick
            let $previousFlexDeliveryStore = $previousFlexDeliveryStoreChecked.find("[data-store-id]").first();
            let previousStoreId = $previousFlexDeliveryStore.data('store-id');
            let previousServicePointId = $previousFlexDeliveryStore.data('service-point-id')
            $(".timeslot-days-slick.selectDeliveryStore[data-store-id=" + previousStoreId + "]").addClass("hide").removeClass('activeDeliveryStore activeDaySlider');

            //show the new days slick
            $(".timeslot-days-slick.selectDeliveryStore[data-service-point-id=" + selectedServicePointId + "][data-store-id=" + selectedStoreId + "]").removeClass("hide").addClass('activeDeliveryStore activeDaySlider');

            //set selected serviceType
            setCurrentServiceType();

            //change footer info
            if (typeof selectedStoreName != 'undefined' && typeof selectedStoreAddress != 'undefined') {
                $('.sp_footer-store-name').text(selectedStoreName + ' ' + selectedStoreAddress);
            }
            if (showFirstAvailableTimeslot) {
                showReservedOrFirstAvailableTimeslot();
            }
            let $inputTimeslotSelected = $(selectDeliveryService).find(activeDeliveryTimeslotContainer).find('input[name="select-timeslot-mpriority_home_delivery"]:checked');
            manageFooterInfo($inputTimeslotSelected, false);
            showHideFlexibleDeliveryBtns();
        });
    }

    function showReservedOrFirstAvailableTimeslot() {
        let $selectedTimeslot = $('.activeTimeslotContainer').find('[data-timeslot-selected=true]').closest('ul');
        let currentServiceType = getCurrentServiceType();
        if ($selectedTimeslot.length && serviceType && (serviceType.toUpperCase() === currentServiceType || (serviceType.toUpperCase() === 'PICKUP' && currentServiceType === SERVICE_TYPE_ECOMM_PICKUP))) {
            let flexibleTimeslotclass = sidePanelControl.goToReservedTimeslot($selectedTimeslot);
            sidePanelControl.showLoadedTimeslotBySelector(flexibleTimeslotclass, getToggleServiceType());
        } else {
            sidePanelControl.showFirstAvailableTimeslot();
        }
    }

    function onCloseModalServiceAndTimeslot() {
        if (!cartHasStore) {
            window['cartItem'] = null;
        }

        if (window['changeTimeslot']) {
            window['storeId'] = false;
            window['changeTimeslot'] = false;
        }

        var reloadPageAuthorized = true;
        if (window['cartItem'] && !window['storeId']) {
            window['executeAddProductToCart'](productToAddToCart, errorBoxForAddToCart, false);
        }

        if (isReloadPageAuthorizedForServiceAndTimeslot(reloadPageAuthorized)) {
            if (isInCheckoutPage()) {
                TINK.inProgress($('body'));
            }
            reloadPage();
            return;
        } else {
            lookupTimeslotConfirmationAlert();
        }

        if (closeServiceAndTimeslotCallback && closeServiceAndTimeslotCallback !== 'reloadPage') {
            var closeCallBack = eval(closeServiceAndTimeslotCallback);
            if (typeof closeCallBack === 'function') {
                closeCallBack(selectedTimeslotId);
            }
        }
        closeServiceAndTimeslotCallback = null;

        replaceContentModalServiceAndTimeslot('', true);
    }

    function isReloadPageAuthorizedForServiceAndTimeslot(reloadPageAuthorized) {
        return (reloadPageAuthorized && (cartStoreHasChanged || cartLoadNewPrices)) || (window.location.pathname === shoppingCartUrl) || (cartTypeHasChanged && isInCheckoutPage());
    }

    function manageBtnShowFlexible(serviceType, showFlexible) {
        if (serviceType === 'delivery') {
            $('.flexiblePickUpText').addClass("hide");
            if (showFlexible) {
                $('.showFlexibleText').removeClass("hide");
                $('.flexibleDeliveryText').removeClass("hide");
                $('.showAllTimeslotText').addClass("hide");
            } else {
                $('.showFlexibleText').addClass("hide");
                $('.flexibleDeliveryText').addClass("hide");
                $('.showAllTimeslotText').removeClass("hide");
            }
        } else {
            $('.flexibleDeliveryText').addClass("hide");
            if (showFlexible) {
                $('.showFlexibleText').removeClass("hide");
                $('.flexiblePickUpText').removeClass("hide");
                $('.showAllTimeslotText ').addClass("hide");
            } else {
                $('.showFlexibleText').addClass("hide");
                $('.flexiblePickUpText').addClass("hide");
                $('.showAllTimeslotText').removeClass("hide");
            }
        }
    }

    function showHideFlexibleDeliveryBtns() {
        if ($('.timeslot-days-slick.selectDeliveryStore:not(.selectFlexibleDeliveryStore)').length > 0 && $('.timeslot-days-slick.selectDeliveryStore.selectFlexibleDeliveryStore').length > 0) {
            if ($('.activeDaySlider').closest("[data-store-id]").attr('data-service-type') === SERVICE_TYPE_ECOMM_DELIVERY) {
                manageBtnShowFlexible('delivery', true);
            } else if ($('.activeDaySlider').closest("[data-store-id]").attr('data-service-type') === SERVICE_TYPE_MPRIORITY_DELIVERY) {
                manageBtnShowFlexible('delivery', false);
            }
        } else {
            $('.showFlexibleText').addClass("hide");
            $('.showAllTimeslotText ').addClass("hide");
        }
    }

    function showHideFlexiblePickupBtns() {
        if ($('.activeDaySlider').closest("[data-store-id]").attr('data-flexible-service-point-id') && $('.activeDaySlider').closest("[data-store-id]").attr('data-pickup-service-point-id')) {
            if ($('.activeDaySlider').closest("[data-store-id]").attr('data-service-type') === SERVICE_TYPE_ECOMM_PICKUP) {
                manageBtnShowFlexible('pickUp', true);
            } else {
                manageBtnShowFlexible('pickUp', false);
            }
        } else {
            $('.flexible-text').addClass("hide");
            $('.showAllTimeslotText ').addClass("hide");
        }
    }

    // Pickup flexible
    function initFlexible() {

        $(".seeAllTimeslot").on("click", _.debounce(function () {
            if ($('.showFlexibleText.hide').length) {
                flexibleFlowManagement('pick_up_in_store', SERVICE_TYPE_ECOMM_PICKUP, 'home_delivery', SERVICE_TYPE_ECOMM_DELIVERY);
                setCurrentServiceType();

                if (getCurrentServiceType() === SERVICE_TYPE_ECOMM_PICKUP) {
                    let $inputTimeslotSelected = $(selectPickupService).find(activePickupTimeslotContainer).find('input[name="select-timeslot-pick_up_in_store"]:checked');
                    manageFooterInfo($inputTimeslotSelected, false);
                    manageBtnShowFlexible('pickUp', true);
                } else if (getCurrentServiceType() === SERVICE_TYPE_ECOMM_DELIVERY) {
                    manageBtnShowFlexible('delivery', true);
                }
            }
        }, 400));

        $('.showTimeslotFlexible').click(function () {

            flexibleFlowManagement('mpriority_pickup', SERVICE_TYPE_MPRIORITY_PICKUP, 'mpriority_home_delivery', SERVICE_TYPE_MPRIORITY_DELIVERY);
            setCurrentServiceType();

            let $serviceTypeChecked = getToggleServiceType();
            let $inputTimeslotSelected;
            if ($serviceTypeChecked === SERVICE_TYPE_ECOMM_PICKUP) {
                showHideFlexiblePickupBtns();
                $inputTimeslotSelected = $(selectPickupService).find(activePickupTimeslotContainer).find('input[name="select-timeslot-mpriority_pickup"]:checked');
                sidePanelControl.manageAlertDisplay($inputTimeslotSelected);

            } else {
                showHideFlexibleDeliveryBtns();
                $inputTimeslotSelected = $(selectDeliveryService).find(activeDeliveryTimeslotContainer).find('input[name="select-timeslot-mpriority_home_delivery"]:checked');
                sidePanelControl.manageAlertDisplay($inputTimeslotSelected);
            }
            manageFooterInfo($inputTimeslotSelected, false);
        });
    }

    // Function Shared between The showTimeslotFlexible Btn and The seeAllTimeslot Btn
    function flexibleFlowManagement(pickupSelector, pickupService, deliverySelector, deliveryService) {
        let $activeDay = $('.activeDaySlider .day__active');
        let $serviceTypeChecked = getToggleServiceType();
        let flexibleTimeslotclass;

        // get the current timeslot
        let currentTimeslotClass = sidePanelControl.getTimeslotByServiceTypeClass($activeDay);
        var $timeslot = $(".activeTimeslotContainer .selection-box." + currentTimeslotClass);

        // hide the current timeslot
        $timeslot.addClass("timeslot-group-inactive");

        // hide timeslot's alerts
        sidePanelControl.hideTimeslotAlert($timeslot);

        if ($serviceTypeChecked === SERVICE_TYPE_ECOMM_PICKUP) {
            // change the current selector to flexible/Pickup service selector
            $('.activeDaySlider .day-selection_btn').map(function () {
                let $this = $(this);
                $this.removeClass(function (index, className) {
                    return (className.match(/\bservice\S+/g) || []).join(' ');
                }).addClass(sidePanelControl.getTimeslotSelectorByServiceTypeAndDay(pickupSelector, $this.attr("data-timeslot-date")));
            });

            // Change the data-service-type to Flexible/Pickup
            $('.activeDaySlider').closest("[data-service-type]").attr('data-service-type', pickupService);

            let $selectedTimeslot = $('.activeTimeslotContainer').find('[data-timeslot-selected=true]').closest('ul');
            if ($selectedTimeslot.length && serviceType && (serviceType.toUpperCase() === pickupService || (serviceType.toUpperCase() === 'PICKUP' && pickupService === SERVICE_TYPE_ECOMM_PICKUP))) {
                flexibleTimeslotclass = sidePanelControl.displayCorrectTimeslotDay();
            } else {
                // get timeslots for the new flexible selector
                let day = selectAppropriateDay($activeDay, pickupService);
                flexibleTimeslotclass = sidePanelControl.getTimeslotSelectorByServiceTypeAndDay(pickupSelector, day);
            }
        } else if ($serviceTypeChecked === SERVICE_TYPE_ECOMM_DELIVERY) {
            if (deliveryService === SERVICE_TYPE_MPRIORITY_DELIVERY) {
                // Show the dropdown of Flexible delivery stores
                $(".flexibleDeliveryDropdown").removeClass("hide");
                $(".flexibleDeliveryTitle").removeClass("hide");

                $('.selection-box.select--delivery-service .flexibleDeliveryDropdown input[name="flexibleDeliveryStoreSelect"][id="flexibleDelivery_0"]').click();
            } else {
                $(".flexibleDeliveryDropdown").addClass("hide");
                $(".flexibleDeliveryTitle").addClass("hide");
            }
            $('.timeslot-days-slick.selectDeliveryStore.activeDeliveryStore').removeClass('activeDeliveryStore').removeClass('activeDaySlider').addClass('hide');
            $(".timeslot-days-slick.selectDeliveryStore[data-service-type=" + deliveryService + "]").first().removeClass('hide').addClass('activeDaySlider').addClass('activeDeliveryStore');

            let $selectedTimeslot = $('[data-timeslot-selected=true]').closest('ul');
            if ($selectedTimeslot.length && serviceType && serviceType.toUpperCase() === deliveryService) {
                flexibleTimeslotclass = sidePanelControl.displayCorrectTimeslotDay();
            } else {
                // go to the selected day
                let day = selectAppropriateDay($activeDay, deliveryService);
                flexibleTimeslotclass = sidePanelControl.getTimeslotSelectorByServiceTypeAndDay(deliverySelector, day);
            }
            $(".timeslotDeliveryContainer").addClass("hide").removeClass("activeTimeslotContainer");

            // add activeTimeslotContainer to the selected timeslot
            let storeId = $('.activeDaySlider').attr("data-store-id");
            $(".timeslotDeliveryContainer[data-store-id=" + storeId + "]").addClass("activeTimeslotContainer").removeClass("hide");
        }

        sidePanelControl.showLoadedTimeslotBySelector(flexibleTimeslotclass, $serviceTypeChecked);
    }

    function selectAppropriateDay($activeDay, serviceType) {
        let timeslotStatus = "data-timeslot-status";
        let day;

        if ($('.activeDaySlider').closest("[data-store-id]").attr("data-init-timeslot") === "false") {
            return sidePanelControl.loadAndShowFirstAvailableTimeslot($('.activeDaySlider'));
        }

        if (serviceType === SERVICE_TYPE_MPRIORITY_PICKUP) {
            timeslotStatus = "data-timeslot-flexible-status";
            let firstAvailableDay = sidePanelControl.getFirstAvailableDay(timeslotStatus);
            day = firstAvailableDay.attr("data-timeslot-date");
            serviceTimeslotControl.slickGoToDay(day);
        } else {
            let firstAvailableDay = sidePanelControl.getFirstAvailableDay(timeslotStatus);
            day = firstAvailableDay.attr("data-timeslot-date");
            serviceTimeslotControl.slickGoToDay(day);
        }
        return day;
    }

    function loadTimeslots(serviceType, storeId, servicePointId, selectedDate, loadedTimeslotDays, serviceCssClass, callback, isDelivery) {
        return new Promise(function (resolve, reject) {
            let postalCode = $('#deliveryPostalCode').val();
            $.ajax({
                url: timeslotFromDateUrl,
                type: 'POST',
                contentType: 'application/json',
                dataType: 'html',
                data: JSON.stringify({
                    'serviceType': serviceType,
                    'storeId': storeId,
                    'servicePointId': servicePointId ? servicePointId : '',
                    'selectedDate': selectedDate,
                    'loadedDays': Array.from(loadedTimeslotDays),
                    'postalCode': postalCode
                }),
                cache: false,
                success: function (data, code, jqXHR) {
                    let parsedHtml = $.parseHTML(data);

                    // Find the child elements (excluding their parent)
                    let childElements = $(parsedHtml).children();

                    let servicePointIdSelector = (isDelivery && servicePointId) ? "[data-service-point-id=" + servicePointId + "]" : "";
                    // Append the child elements to a target element
                    let timeslotContainer = $(".selection-box-container" + serviceCssClass + "[data-store-id=" + storeId + "]" + servicePointIdSelector);
                    if (timeslotContainer.append(childElements)) {

                        childElements.each(function (index) {
                            var $btn;
                            if (isDelivery) {
                                $btn = $(".day-selection_btn." + callback($(this)));
                            } else {
                                $btn = $(".activeDaySlider .day-selection_btn." + callback($(this)));
                            }
                            $btn.attr('data-timeslot-isloaded', 'true');

                            let $child = childElements.eq(index);
                            let serviceTypeSelector = sidePanelControl.getTimeslotByServiceTypeClass($child);
                            if (timeslotContainer.find('.' + serviceTypeSelector).length > 1) {
                                timeslotContainer.find('.' + serviceTypeSelector).get(1).remove();
                            }

                            if ($child.children().length === 0) { // fix bug returned by Hybris
                                if (serviceType == "MPRIORITY_PICKUP") {
                                    $btn.attr('data-timeslot-flexible-status', 'NO_TIMESLOT');
                                } else {
                                    $btn.attr('data-timeslot-status', 'NO_TIMESLOT');
                                }
                            } else if ($btn.attr('data-timeslot-status') === undefined || $btn.attr('data-timeslot-status') === null) {
                                if (serviceType == "MPRIORITY_PICKUP") {
                                    $btn.attr('data-timeslot-flexible-status', 'AVAILABLE');
                                } else {
                                    $btn.attr('data-timeslot-status', 'AVAILABLE');
                                }
                            }
                        });

                        resolve(data);
                    }
                    bindTimeslotButtons();
                },
                error: function (jqXHR) {
                    TINK.redirectIfConflict(jqXHR);
                }
            });
        });
    }

    //!****************************************************************
    // Util
    //!****************************************************************
    //
    function isServiceTimeslotWebviewMode() {
        return isInWebview() && typeof serviceTimeslotWebviewMode !== 'undefined' && serviceTimeslotWebviewMode;
    }

    function bindWebviewEvents() {
        if (isAuthenticated) {
            $('#openServiceForm').click();
        } else {
            // send event to redirect to connection page in the App
            sendUserNotAuthenticatedEventToDevice();
            return;
        }
    }

    function deactivateServiceAndTimeslotButtons($container) {
        if ($container === undefined) {
            $container = $(serviceAndTimeslotClass);
        }
        $container.find('button').attr('disabled', true);
    }

    function setTimeslotConfirmationAlert() {
        sessionStorage.setItem("timeslot-display-confirmation-alert", 'true');
    }

    function lookupTimeslotConfirmationAlert() {
        let display = sessionStorage.getItem("timeslot-display-confirmation-alert");
        if (display === 'true') {
            sessionStorage.removeItem("timeslot-display-confirmation-alert");
            showTimeslotConfirmationAlert();
        }
    }

    function showTimeslotConfirmationAlert() {
        let $timeSlotAlertBanner = $('.timeslot-reservation-alert');
        if ($timeSlotAlertBanner.length) {
            let isCheckoutPage = isInCheckoutPage();
            if (TINK.matchMediaMobile() && !isCheckoutPage) {
                $timeSlotAlertBanner.clone().insertBefore($('.nav-menu-slide-container > ul'));
                let $burgerTimeSlotAlertBanner = $('.nav-menu-slide-container .timeslot-reservation-alert');
                $burgerTimeSlotAlertBanner.show().focus();
                setTimeout(function () {
                    $burgerTimeSlotAlertBanner.fadeOut('slow', function () {
                        $burgerTimeSlotAlertBanner.remove();
                    })
                }, 3000);
            }
            $timeSlotAlertBanner.show();
            if (isCheckoutPage) {
                let $timeSlotReservation = $('#timeSlotReservation');
                if ($timeSlotReservation.length) {
                    $('html, body').animate({scrollTop: $($timeSlotReservation).position().top - 15}, 'slow');
                }
            }
            setTimeout(function () {
                $timeSlotAlertBanner.fadeOut('slow');
            }, 3500);
        }
    }

    function getToggleServiceType() {
        return $(serviceAndTimeslotClass + ' input[name="radioServiceType"]:checked').val();
    }

    //!****************************************************************
    // Update dom
    //!****************************************************************

    function updateCartHasStore(jqXHR) {
        cartHasStore = jqXHR.getResponseHeader('cartHasStore') === 'true';
    }

    function updateCartWithoutTimeslot(timeslotSelected) {
        cartWithoutTimeslot = timeslotSelected;
    }

    function displayCaptchaError($alertElem) {
        if ($alertElem.length) {
            $alertElem.show();
            $alertElem.children('ul').attr('tabindex', '1');
            $alertElem.children('ul').focus();
        }
    }

    function updateHeaderAfterServiceAndTimeslotRequest(jqXHR, pushDataLayerTimeslot, pushDataLayerCriterias) {
        if (jqXHR.getResponseHeader('updateHeader') === 'true') {
            let timeslot = jqXHR.getResponseHeader('updateHeaderTimeslot');
            let timeslotText = jqXHR.getResponseHeader('updateHeaderTimeslotText');
            let timeslotDate = jqXHR.getResponseHeader('updateHeaderTimeslotDate');
            let timeslotHour = jqXHR.getResponseHeader('updateHeaderTimeslotHour');
            let timeslotDescription = jqXHR.getResponseHeader('updateHeaderTimeslotDescription');

            if (pushDataLayerTimeslot) {
                pushDataLayerServiceAndTimeslotTimeslot(jqXHR.getResponseHeader('updateHeaderTimeslotMetricsDatetime'));
            } else if (pushDataLayerCriterias) {
                pushDataLayerServiceAndTimeslotCriteriasForm();
            }
            updateHeaderAfterServiceAndTimeslot(jqXHR.getResponseHeader('updateHeaderStore'),
                timeslot,
                jqXHR.getResponseHeader('updateHeaderPickup') === 'true',
                jqXHR.getResponseHeader('updateHeaderExpressDelivery') === 'true',
                timeslotText,
                timeslotDescription,
                timeslotHour);
            updateCheckoutAfterServiceAndTimeslot(timeslotDate, timeslotHour);
        }
    }

    function updateHeaderAfterServiceAndTimeslot(storeName, timeSlot, forPickup, forExpressDelivery, timeslotText, timeslotDescription, timeslotHour) {
        if ($('#banner-service-and-timeslot').length) {
            if (storeName) {
                if (forPickup) {
                    $('.locationPickup .openStoreLocatorName').text(storeName);
                    $('.locationPickup').removeClass('hide');
                    $('.openStoreLocatorPickup').removeClass('hide');
                    $('.openStoreLocatorDelivery').addClass('hide');
                    $('.openStoreLocatorPickup').closest('span.action__edit--service').removeClass('hide').addClass('text-same-line');
                    $('.icon--service-template.openBanner').find('img').attr("src", "/images/shared/small/icons/icon-notification-grocery.svg");
                    $('.data-container-GA .data-service-type-GA').data('ga-service-type', 'pick-up');
                } else {
                    $('.locationPickup .openStoreLocatorName').text('');
                    $('.openStoreLocatorDelivery .openStoreLocatorName').text(storeName).mask('S0S 0S0');
                    $('.openStoreLocatorDelivery').removeClass('hide');
                    $('.openStoreLocatorPickup').addClass('hide');
                    $('.openStoreLocatorDelivery').closest('span.action__edit--service').removeClass('hide').addClass('text-same-line');
                    $('.icon--service-template.openBanner').find('img').attr("src", "/images/shared/small/icons/icon-notification-delivery.svg");
                    $('.data-container-GA .data-service-type-GA').data('ga-service-type', 'delivery');
                }

                $('.action__select--service.serviceText').addClass('hide');
                $('.action__select--service.openStoreLocatorTimeslotWrapper').addClass('hide');
                $('.ipDetection, .favoriteStore').addClass('hide');
                $('.openStoreLocatorTimeslotWrapper #timeslot-text').html(timeslotText);
                $('.action__edit--service.openStoreLocatorTimeslotWrapper').removeClass('hide').addClass('text-same-line');
            }

            if ((timeslotHour === undefined || timeslotHour === '') && !forExpressDelivery) {
                $('.action__edit--service .openStoreLocatorTimeslotValue.setTimeslot').removeClass('hide');
            } else if (timeslotHour !== undefined && timeslotHour !== '' || forExpressDelivery) {
                $('.action__edit--service .openStoreLocatorTimeslotValue.setTimeslot').addClass('hide');
            }

            if (timeSlot) {
                if (forExpressDelivery) {
                    $('.action__edit--service .openStoreLocatorTimeslotValue.timeslotHour').text(timeSlot);
                    $('.action__edit--service .openStoreLocatorTimeslotValue.timeslotDescription').addClass('hide');
                } else {
                    $('.action__edit--service .openStoreLocatorTimeslotValue.timeslotHour').text(timeslotHour);
                    $('.action__edit--service .openStoreLocatorTimeslotValue.timeslotDescription').text(timeslotDescription).removeClass('hide');
                }
            }
        }
    }

    function updateCheckoutAfterServiceAndTimeslot(timeslotDate, timeslotHour) {
        if (isInCheckoutPage()) {
            $('.orderDate').text(timeslotDate);
            $('.orderTime').text(timeslotHour);
        }
    }

    function isModalServiceAndTimeslotOpen() {
        return $('.st_panel.remodal-is-opened').length;
    }

    //****************************************************************
    // Expose
    //****************************************************************
    return {
        init: init,
        bindCaptcha: bindCaptcha,
        openServiceAndTimeslot: openServiceAndTimeslot,
        loadTimeslots: loadTimeslots,
        manageFooterInfo: manageFooterInfo,
        getToggleServiceType: getToggleServiceType,
        onCloseModalServiceAndTimeslot: onCloseModalServiceAndTimeslot,
        updateCartHasStore: updateCartHasStore,
        updateHeaderAfterServiceAndTimeslotRequest: updateHeaderAfterServiceAndTimeslotRequest,
        isModalServiceAndTimeslotOpen: isModalServiceAndTimeslotOpen,
        setCurrentServiceType: setCurrentServiceType,
        getCurrentServiceType: getCurrentServiceType,
        updateCartWithoutTimeslot: updateCartWithoutTimeslot,
        manageBtnShowFlexible: manageBtnShowFlexible,
        bindCloseButton: bindCloseButton,
        SERVICE_TYPE_ECOMM_PICKUP: SERVICE_TYPE_ECOMM_PICKUP,
        SERVICE_TYPE_MPRIORITY_PICKUP: SERVICE_TYPE_MPRIORITY_PICKUP,
        SERVICE_TYPE_ECOMM_DELIVERY: SERVICE_TYPE_ECOMM_DELIVERY,
        SERVICE_TYPE_MPRIORITY_DELIVERY: SERVICE_TYPE_MPRIORITY_DELIVERY,
        SERVICE_TYPE_EXPRESS_DELIVERY: SERVICE_TYPE_EXPRESS_DELIVERY
    }
}();

const stickyTimeslotBanner = function () {
    let $bannerServiceAndTimeslot = $('#banner-service-and-timeslot');

    if ($bannerServiceAndTimeslot.length >= 1  && !Revealizr.isMobileSize) {
        let viewportTop = 0;

        const changeStateOnScroll = function () {
            viewportTop = $(window).scrollTop();
            if (viewportTop > 30) {
                $bannerServiceAndTimeslot.addClass('reduced');
            } else {
                $bannerServiceAndTimeslot.removeClass('reduced');
            }
        };

        $(window).on('scroll', _.debounce(changeStateOnScroll, 200));
    }
}


$(document).ready(function () {
    ServiceTimeslot.init();
});